import { render, staticRenderFns } from "./JoinEventInDubai.vue?vue&type=template&id=435adf48&scoped=true"
import script from "./JoinEventInDubai.vue?vue&type=script&lang=js"
export * from "./JoinEventInDubai.vue?vue&type=script&lang=js"
import style0 from "./JoinEventInDubai.vue?vue&type=style&index=0&id=435adf48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435adf48",
  null
  
)

export default component.exports